import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ClientOptionsDispatchers, SessionSelectors } from '@store';
import { switchMap } from 'rxjs/operators';
import { StatistikService } from 'app/statistik/statistik.service';

@Component({
    selector: 'app-statistik-netomsla',
    template: `
    <app-statistik-netomsla-ui
      [fakturaer]="fakturaer$ | async"
      [fakturaer2]="fakturaer2$ | async"
      [fakturaer3]="fakturaer3$ | async"
      [periode]="periode$ | async"
      [periode2]="periode2$ | async"
      [periode3]="periode3$ | async"
      [laCards]="laCards$ | async"
      (periodeChange)="periodeChange($event)"
    ></app-statistik-netomsla-ui>
  `,
    styleUrl: './statistik-netomsla.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikNetomslaContainerComponent {
    periodeSubject = new BehaviorSubject<{ fra: string, til: string }>({ fra: null, til: null });
    periode2Subject = new BehaviorSubject<{ fra: string, til: string }>({ fra: null, til: null });
    periode3Subject = new BehaviorSubject<{ fra: string, til: string }>({ fra: null, til: null });
    periode$ = this.periodeSubject.asObservable();
    periode2$ = this.periode2Subject.asObservable();
    periode3$ = this.periode3Subject.asObservable();

    laCards$ = this.periode$.pipe(switchMap(periode => this.sessionSelector.usersLA$(new Date(periode.fra))));

    fakturaer$ = this.periode$.pipe(switchMap(periode => this.statistikService.getNetomsla(periode)));
    fakturaer2$ = this.periode2$.pipe(switchMap(periode => this.statistikService.getNetomsla(periode)));
    fakturaer3$ = this.periode3$.pipe(switchMap(periode => this.statistikService.getNetomsla(periode)));

    periodeChange(periode: { fra: string; til: string }) {
        this.periodeSubject.next(periode);
        this.periode2Subject.next(this.createModifiedPeriode(periode, 1));
        this.periode3Subject.next(this.createModifiedPeriode(periode, 2));
    }

    private createModifiedPeriode(periode: { fra: string, til: string }, subtract: number): { fra: string, til: string } {
        const changePeriode = (str: string, subtract: number): string => {
            const num = parseInt(str.slice(0, 4));
            const result = (num - subtract).toString().padStart(4, '0');
            return result + str.slice(4);
        };
        return {
            fra: changePeriode(periode.fra, subtract),
            til: changePeriode(periode.til, subtract)
        };
    }

    constructor(
        private sessionSelector: SessionSelectors,
        private clientsOptionsDispatch: ClientOptionsDispatchers,
        private statistikService: StatistikService
    ) {
        this.clientsOptionsDispatch.loadClientOptions();
    }
}
